/**
 * GraphQLから取得した投稿日を表示用に整形する
 * MEMO: ビルド速度を重視してDateオブジェクトなどは利用せず、文字列操作のみで完結させている
 * @param rawDate GraphQLから取得した投稿日の文字列
 * @returns yyyy年m月d日 の文字列 (一桁の月日は一桁で表示)
 */
const formatDateText = (rawDate: string): string => {
  const year = rawDate.slice(0, 4);
  const m2 = rawDate.slice(5, 6); // 月 2桁目
  const m1 = rawDate.slice(6, 7); // 月 1桁目
  const d2 = rawDate.slice(8, 9); // 日 2桁目
  const d1 = rawDate.slice(9, 10); // 日 1桁目

  const month = m2 === '0' ? m1 : `${m2}${m1}`; // 月が1〜9なら2桁目の0は不要
  const day = d2 === '0' ? d1 : `${d2}${d1}`; // 日が1〜9なら2桁目の0は不要

  return `${year}年${month}月${day}日`;
};

export default formatDateText;
